import { render } from "./TheAposAdminBarUser.vue?vue&type=template&id=15abe123&scoped=true"
import script from "./TheAposAdminBarUser.vue?vue&type=script&lang=js"
export * from "./TheAposAdminBarUser.vue?vue&type=script&lang=js"

import "./TheAposAdminBarUser.vue?vue&type=style&index=0&id=15abe123&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15abe123"],['__file',"admin-bar/ui/apos/components/TheAposAdminBarUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15abe123"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15abe123', __exports__)) {
    api.reload('15abe123', __exports__)
  }
  
  module.hot.accept("./TheAposAdminBarUser.vue?vue&type=template&id=15abe123&scoped=true", () => {
    api.rerender('15abe123', render)
  })

}


export default __exports__